import { createFileRoute } from "@tanstack/react-router";

import { ReportsPage } from "../../../workspaces/reports/pages/ReportsPage";

export const Route = createFileRoute("/_console/p/$org/$project/reports/")({
  component: ReportsPage,
});
